module.exports = __webpack_public_path__ + "img/ES.03598908.svg";